import { Timeframe } from '@griply/types';
import { format, isSameDay } from 'date-fns';

export type GetDateBarTooltipOptions = {
  value: number;
  target?: number;
  timeframe: Timeframe;
};

export const getDateBarTooltip = ({
  value,
  target,
  timeframe,
}: GetDateBarTooltipOptions) => {
  const valString = target ? `${value}/${target}` : value;

  if (isSameDay(timeframe.startDate, timeframe.endDate)) {
    return `${valString} (${format(timeframe.startDate, 'MMM d')})`;
  }

  return `${valString} (${format(timeframe.startDate, 'MMM d')} - ${format(timeframe.endDate, 'MMM d')})`;
};
